import React from 'react';
import { Layout, Table, Divider, Typography, Button, Row, Col, Space, Popconfirm, message } from 'antd';
import CategoryEdit from 'containers/category/categoryEdit';
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    ReloadOutlined,
} from '@ant-design/icons';

const { Content } = Layout;
const { Title } = Typography;

const data = [
    {
        key: 1,
        name: '景点',
        children: [
            {
                key: 101,
                name: '自由行',
                children: [
                    {
                        key: 10101,
                        name: '三级分类01'
                    },
                    {
                        key: 100102,
                        name: '三级分类02'
                    },
                    {
                        key: 100103,
                        name: '三级分类03'
                    }
                ]
            },
            {
                key: 102,
                name: '半日游',
            },
            {
                key: 103,
                name: '一日游',
            },
        ],
    },
    {
        key: 2,
        name: '门票',
        children: [
            {
                key: 201,
                name: "景点门票"
            },
            {
                key: 202,
                name: "表演门票"
            },
            {
                key: 203,
                name: "主题门票"
            }
        ]
    },
    {
        key: 3,
        name: "酒店",
        children: [
            {
                key: 301,
                name: "酒店"
            },
            {
                key: 302,
                name: "别墅"
            },
            {
                key: 303,
                name: "民宿"
            }

        ]
    },
    {
        key: 4,
        name: "交通",
        children: [
            {
                key: 401,
                name: "包车"
            },
            {
                key: 402,
                name: "租车"
            },
            {
                key: 403,
                name: "机场接送"
            },
            {
                key: 404,
                name: "酒店接送"
            },
        ]
    }
];

class CategoryList extends React.Component {

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(props: any) {
        super(props);
    }

    state = ({
        defaultExpandAllRows: false, //是否默认展示所有行
        dataId: 0,
        editorVisible: false,
        editorTitle: '',
    })

    columns = [
        {
            title: '分类名称',
            dataIndex: 'name',
            key: 'name',
            width: '20%'
        },
        {
            title: '排序',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: "key",
            render: (text: any) =>
                <Space>
                    <Button shape="round" onClick={this.editData.bind(this, text)}><EditOutlined /> 编辑</Button>
                    <Popconfirm placement="left" title="确认删除此条记录吗？" onConfirm={this.deleteConfirm.bind(this, text)} okText="确认" cancelText="取消">
                        <Button shape="round"><DeleteOutlined />删除</Button>
                    </Popconfirm>
                </Space>
        },
    ];


    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增分类"
        })
    }

    editData = (text: number): any => {
        this.setState({
            editorVisible: true,
            editorTitle: "编辑分类 id- " + text.toString()
        })
    }

    cancelModal = () => {
        this.setState({
            editorVisible: false
        })
    }

    changeTree = (status: any) => {
        console.log('status', status)
        this.setState({
            defaultExpandAllRows: status,
        })
    }

    deleteConfirm = (text: any) => {
        message.warning('点击删除记录');
    }

    render() {
        return (
            <div>
                <div className="page-title">
                    <Title level={3}>商品分类</Title>
                </div>

                <Divider />

                <Row gutter={[18, 18]}>
                    <Col><Button type="primary" onClick={this.createData.bind(this)}><PlusOutlined /> 新增</Button></Col>
                    <Col><Button onClick={() => { window.location.reload() }}><ReloadOutlined /> 刷新</Button></Col>
                    {/* <Col><Button onClick={this.changeTree.bind(this, true)}>全部展开</Button></Col>
                        <Col><Button onClick={this.changeTree.bind(this, false)}>全部收起</Button></Col> */}
                </Row>
                <Table
                    columns={this.columns}
                    dataSource={data}
                    expandable={{
                        defaultExpandAllRows: this.state.defaultExpandAllRows,
                    }}
                    pagination={false}
                />
                <CategoryEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
            </div>
        )
    }
}

export default CategoryList;